// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__HR70y","label":"styles_label__g2ojW","title":"styles_title__TO_IA","subTitle":"styles_subTitle__zVyJg"};